export async function setNodeData(nodes, transform) {
    await this.execute(
        () => this.actions.setNodeData(nodes, transform)
    )
}
